// components/RestaurantPOS/waiters/Footer.jsx
import React from 'react';
import restaurantConfig from '../../../config/Organisation_Details';
import logo from '../../../assets/elegantelogo.png';

const Footer = () => {
  return (
    <footer className="epos-footer">
      <div className="footer-left">
        <span className="footer-version">v2.4.0</span>
        <span className="footer-divider"></span>
        <span className="footer-brand">
          Sales Point
        </span>
      </div>
      <div className="footer-right">
        <span className="footer-brand">Designed by</span>
        <img src={logo} alt={restaurantConfig.name} className="footer-logo-small" />
        <span className="footer-brand">IT Dept.</span>
        <span className="footer-divider"></span>
        <span className="footer-tagline">{restaurantConfig.slogan}</span>
        <span className="footer-divider"></span>
        <span className="footer-version">{restaurantConfig.phone}</span>
      </div>
    </footer>
  );
};

export default Footer;